import type { Creature } from './types';
import type { Genome } from '@/domain/genetics/types';
import { generateCuteName } from './name';
import { createCareProfile } from '@/domain/care/profile';

export interface MkCreatureInput {
  genome: Genome;
  id: string;
  nowMs: number;
  name?: string;
}

export function mkCreature(input: MkCreatureInput): Creature {
  const name = input.name ?? generateCuteName();
  return {
    id: input.id,
    name,
    genome: input.genome,
    state: {
      hunger: 100,
      happiness: 100,
      weight: 50,
      discipline: 50,
      poopCount: 0,
      lastPoopAt: input.nowMs,
      dead: false,
      causeOfDeath: null,
      tantrum: false,
      tantrumStartedAt: null,
      attentionLowSince: null,
      sick: false,
      sickSince: null,
      healDoses: 0,
      lastHealAt: null,
      lowHealthSince: null,
      vitality: 100,
    },
    lifecycle: {
      stage: 'egg',
      bornAt: input.nowMs,
      elderSince: null,
      careTraits: [],
      teenEntryProfile: null,
      careTier: null,
      careFinalScore: null,
    },
    careProfile: createCareProfile(),
  };
}
